import React, { useEffect } from "react"
import "./EmbedHolder.scss"
import { WithApi } from "@api"

interface EmbedConfig {
  apiBase: string,
  env: "development" | "production",
  // authToken: string,
}

export const EmbedHolderCSSRoot: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className="neo__embedHolder">{children}</div>
}

export const EmbedSurroundThatSetsThemedPageBackground: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className='neo__embedPageSurroundThatSetsThemedPageBackground'>
    <div>
      {children}
    </div>
  </div>
}

const EmbedHolder: React.FC<React.PropsWithChildren> = ({ children }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const conf = (window as any).__sdquizConfig as EmbedConfig

  const hasConf = !!conf

  useEffect(() => {
    if (!hasConf) {
      console.error('No quiz/raffle embed config present. Make sure to include javascript tag "https://sueddeutsche.de/quiz/__embed"')
    }
  }, [hasConf])

  if (!conf) {
    return null
  }

  return <EmbedHolderCSSRoot>
    <WithApi apiEndpoint={`${conf.apiBase}`} locale='de' authToken={undefined}>
      {children}
    </WithApi>
  </EmbedHolderCSSRoot>
}

export default EmbedHolder
